import { useState } from "react";
import { useEffect } from "react"
import { useSearchParams } from 'react-router-dom';
import { Proof } from "./Proof";
import { AnnotationViewer } from "./AnnotationViewer";
import { Annotorious } from "@annotorious/react";
import React from "react";

class ViewNotesEBoundary extends React.Component<{children: React.ReactNode}>{
    constructor(props: {children: React.ReactNode}){
        super(props);
        this.state={hasError:false}
    }

    static getDerivedStateFromError(error: Error){
        return {hasError:true}
    }
    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.log(error);
        console.log(errorInfo.componentStack);
    }
    render(): React.ReactNode {
        return this.props.children;
    }
}

export default function ViewNotes (){
    const [SearchParams] = useSearchParams();
    const element = SearchParams.get('a')||"";
    const edit = SearchParams.get('edit')=="y"?true:false;
    const user = SearchParams.get('user')||"";


    const checkQuery=()=>{
    }

    useEffect(()=>{
        checkQuery();
    },[])

    return(
        <ViewNotesEBoundary>
        <div className="mt-3" style={{height:"calc(vh - 120px", overflow:"scroll"}}>
        <h5>Annotations for: {element}</h5>
        <Annotorious>
        <AnnotationViewer element={element} username="" userFull="" thumbUrl="" />
        </Annotorious>
        </div>
        </ViewNotesEBoundary>
    )
}